import { useSelector } from "react-redux";
import props from "../../../redux/props";
import {
  HistoryRelativeWrapper,
  StyledHistory,
  Box,
  Text,
  Link,
} from "./History.Styled";

const History = () => {
  const translation = useSelector((s) => s[props.TRANSLATION]);

  return (
    <HistoryRelativeWrapper>
      <StyledHistory>
        <Box>
          <Text>
            {translation.career.history.prefix}
            <Link href={translation.career.history.link.href}>
              {translation.career.history.link.text}
            </Link>
          </Text>
        </Box>
      </StyledHistory>
    </HistoryRelativeWrapper>
  );
};

export default History;
